import styled from 'styled-components';


// define globally used classes
const StyledApp = styled.div`
.relative {
  position: relative;
}
  .flex {
    display: flex;
    &-col {
      flex-flow: column;
    }
  }

  .text-sm {
    font-size: 0.75rem
  }
  .text-xs {
    font-size: 0.5rem
  }
  
  .justify-start {
    justify-content: flex-start;
  }
  .justify-center {
    justify-content: center;
  }
  .items-center {
    align-items: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-between {
    justify-content: space-between;
  }
  .gap-6 {
    gap: 1.25rem;
  }

  .mt-2 {
    margin-top: 0.5rem;
  }
  .mt-4 {
    margin-top: 1rem;
  }
  .mt-8 {
    margin-top: 2rem;
  } 
  .ml-8 {
    margin-left: 2rem;
  } 
  .mb-4 {
    margin-bottom: 1rem;
  }
  .flex-row-dynamic {
    flex-flow: row;
    @media (max-width: 500px) {
      flex-flow: column;
    }
  }
  .text-center {
    text-align: center;
  }
`;

export default StyledApp;
